import styled, { css } from 'styled-components';
import { defaultInputStyle, validInputStyle } from '../Input/InputStyle';
import { scrollbarHide } from '@styles/variants/scrollbar';

const transparentStyle = css`
  padding: 8px 0;

  border: 0;
  border-radius: 0;
  background-color: transparent;

  &:hover,
  &:focus {
    border: 0;
  }

  &:focus {
    box-shadow: none;
  }

  width: auto;
  ${scrollbarHide}
`;

const TextareaBase = styled.textarea<{
  isValid?: boolean;
  transparent?: boolean;
}>`
  width: 100%;
  font-family: inherit;
  background: none;
  font-size: var(--textSize);
  line-height: 1.3;
  outline: none;
  resize: none;
  transition: border 0.2s;
  border-radius: var(--cardBorderRadius);
  overflow-y: scroll;
  line-height: 21px;
  color: var(--textColor);
  border: 1px solid var(--lineColor);
  background-color: var(--cardBackgroundColor);

  &::placeholder {
    font-size: var(--textSize);
    color: var(--subTextColor);
  }

  &:focus {
    outline: none;
  }

  ${({ isValid }) => (!isValid ? defaultInputStyle : validInputStyle)};
  ${({ transparent }) => transparent && transparentStyle};
`;

export default TextareaBase;
